import { alpha } from "@mui/material/styles";

/** Same gradient + base as `SidebarLayout` / `AppBarLayout` AppBar. */
export function getAppBarSurface(theme) {
  const base = theme.palette.dark?.light || theme.palette.dark?.main || "#111";
  return `linear-gradient(180deg, ${alpha(theme.palette.primary.main, 0.48)} 0%, ${alpha(theme.palette.primary.main, 0.28)} 55%, ${alpha(theme.palette.info.main, 0.18)} 100%), ${base}`;
}
